import * as React from 'react';
import PulsoidClient from '../PulsoidClient';
import {useEffect, useState} from 'react';

export const SHOW_WHEN_PREMIUM = 'SHOW_WHEN_PREMIUM';
export const SHOW_WHEN_NOT_PREMIUM = 'SHOW_WHEN_NOT_PREMIUM';

export const PremiumComponentWrapper = ({mode, children}) => {
  const [premiumInfo, setPremiumInfo] = useState(null);

  useEffect(() => {
    new PulsoidClient().getPremiumInfo().then((p) => setPremiumInfo(p));
  }, []);

  if (premiumInfo) {
    if (mode === SHOW_WHEN_NOT_PREMIUM && !premiumInfo.isPremium) {
      return children;
    } else if (mode === SHOW_WHEN_PREMIUM && premiumInfo.isPremium) {
      return children;
    } else {
      return <></>;
    }
  } else {
    return <></>;
  }
};
